import React from 'react'
import { IAppTableColumnProps } from './AppTableColumn'
export interface TableConfig {
  leftColumns?: IAppTableColumnProps[]
  rightColumns?: IAppTableColumnProps[]
  columns?: IAppTableColumnProps[]
  tree?: boolean
  multSelect?: boolean
  leftAreaWidth?: number
  rightAreaWidth?: number
  tableWidth?: number
  currentWidth?: number
}

export interface ITableLayout {
  contentWidth: number
  bodyHeight: number
  marginright: string
}

export function getTableConfig(children: React.ReactNode) {
  let tableConfig = {
    leftColumns: [],
    rightColumns: [],
    columns: [],
    tree: false,
    multSelect: false,
    leftAreaWidth: 0,
    rightAreaWidth: 0,
    tableWidth: 0,
  } as TableConfig

  let tableColumns = React.Children.toArray(children).filter((c: any) => c.type !== React.Fragment)
  let leftFixIndex = -1 // 左边固定区域
  let rightFixIndex = -1 // 右边固定区域

  for (let i = 0; i < tableColumns.length; i++) {
    let column = tableColumns[i] as any
    let columnProps = column.props as IAppTableColumnProps
    // 左边的区域取最大的值
    if (columnProps.fixed && columnProps.fixed === 'left' && i > leftFixIndex) {
      leftFixIndex = i
    }
    // 右边的区域取最小的值
    if (columnProps.fixed && columnProps.fixed === 'right' && rightFixIndex === -1) {
      rightFixIndex = i
    }

    if (columnProps.field && columnProps.field === '__table_check_box') {
      tableConfig.multSelect = true
    }
    if (columnProps.expand) {
      tableConfig.tree = true
    }
  }

  let leftAreaWidth = 0
  let rightAreaWidth = 0
  let tableWidth = 0
  let freeColumnNum = 0

  for (let i = 0; i < tableColumns.length; i++) {
    let column = tableColumns[i] as any
    let columnProps = column.props as IAppTableColumnProps

    if (i <= leftFixIndex) {
      columnProps = { ...columnProps, width: columnProps.width || 100 }
      tableConfig.leftColumns.push(columnProps)
      leftAreaWidth += columnProps.width
    } else if (leftFixIndex !== -1 && i >= rightFixIndex && rightFixIndex !== -1) {
      columnProps = { ...columnProps, width: columnProps.width || 100 }
      tableConfig.rightColumns.push(columnProps)
      rightAreaWidth += columnProps.width
    } else {
      columnProps = { ...columnProps, width: columnProps.width || 0 }
    }

    if (columnProps.width === 0) freeColumnNum++

    tableConfig.columns.push(columnProps)
    tableWidth += columnProps.width
  }
  // tableWidth = 最小等于自由宽度*100
  tableWidth += freeColumnNum * 100
  return { ...tableConfig, leftAreaWidth, rightAreaWidth, tableWidth }
}

export function resizeTableBody({ target }: Event) {
  console.log('resizeTableBody:', target)
}

// 加工table数据 非树形
export function toData(data: any[], bgnIndex: number) {
  data.forEach((item: any, index) => {
    item.__table_index = bgnIndex + index + 1
    item.__table_checked = false
    item.__tree_hidden = false
  })

  return data
}

// 加工成控件需要的数据结构 expandLevel 默认展开层级
export function toTreeData(treeData: any[], expandLevel?: number) {
  let miniLevel = treeData.length > 0 ? treeData[0].level : 1
  expandLevel = expandLevel || 3
  expandLevel = expandLevel + miniLevel - 1

  treeData.forEach((item: any, index) => {
    item.__table_index = index + 1
    item.__tree_hidden = item.level > expandLevel
    item.__tree_blank_width = ((item.isEnd === 1 ? 1 : 0) + item.level - miniLevel) * 15 + 5
    item.__tree_expand_icon = item.level < expandLevel ? 'caret-down' : 'caret-right'
    item.__table_checked = false
    item.__tree_indeterminate = false
  })
  return treeData
}

// 展开图标
export function handleExpand(rowData: any, treeData: any[]) {
  let ishow = rowData.__tree_expand_icon === 'caret-right'
  let id = rowData.id
  if (ishow) {
    for (let d of treeData) {
      if (d.parentId === id) d.__tree_hidden = false
      if (d.id === id) d.__tree_expand_icon = 'caret-down'
    }
  } else {
    let fullCode = rowData.fullCode + '.'
    for (let d of treeData) {
      if (d.fullCode.indexOf(fullCode) === 0) {
        d.__tree_hidden = true
        d.__tree_expand_icon = 'caret-right'
      }
      if (d.id === id) d.__tree_expand_icon = 'caret-right'
    }
  }
  return treeData
}

// 全选事件
export function handleCheckAll(data: any[], checked: boolean) {
  data.forEach((item: any, index) => {
    item.__table_checked = checked
  })
  return data
}

// 判断全选的状态
export function getAllSelectStatus(data: any[]) {
  let dataLength = data.length
  if (dataLength === 0) return 1

  let checkDataLength = data.filter(e => e.__table_checked).length
  if (checkDataLength === 0) return 1
  if (checkDataLength === dataLength) return 3
  return 2
}

// 树形结构选中事件
export function treeSelected(dataList: any[], currentData: any, checked: boolean) {
  let currFullCode = currentData.fullCode

  dataList.forEach((data: any) => {
    if (data.isEnd === 1) {
      if (currentData.isEnd === 1 && data.fullCode === currFullCode) {
        data.__table_checked = checked
      }
      if (currentData.isEnd === 0 && data.fullCode.indexOf(currFullCode + '.') === 0) {
        data.__table_checked = checked
      }
    }
  })

  // 再处理非末级别数据
  dataList.forEach((data: any) => {
    if (data.isEnd === 0) {
      let fullCode = data.fullCode + '.'
      let children = dataList.filter(e => e.fullCode.indexOf(fullCode) === 0 && e.isEnd === 1)
      let selectStatus = getAllSelectStatus(children)
      data.__tree_indeterminate = selectStatus === 2
      data.__table_checked = selectStatus === 3
    }
  })
  return dataList
}

export function handleScroll({ target }: any, isScroll?: boolean, handle?: (ishidden: boolean) => void) {
  let scrollLeft = target.scrollLeft
  let scrollTop = target.scrollTop
  let offsetWidth = target.scrollWidth - target.clientWidth

  let parentElement = target.parentElement.parentElement

  let mainHeader = parentElement.querySelector('.app-table-header-inner')
  let leftBody = parentElement.querySelector('.app-table-body-left-fixed')
  let rightBody = parentElement.querySelector('.app-table-body-right-fixed')

  if (scrollLeft > 0 && (isScroll === true)) {
    handle && handle(!isScroll)
    isScroll = false
  }
  if (scrollLeft === 0 && (isScroll === false)) {
    handle && handle(!isScroll)
    isScroll = true
  }
  if (mainHeader) mainHeader.scrollLeft = scrollLeft
  if (leftBody) {
    leftBody.scrollTop = scrollTop
    // 如果是滚动条在最左边
    leftBody.parentElement.style.display = scrollLeft === 0 ? 'none' : 'inherit'
  }
  if (rightBody) {
    rightBody.scrollTop = scrollTop
    // 如果是滚动条在最右边
    rightBody.parentElement.style.display = scrollLeft === offsetWidth ? 'none' : 'inherit'
  }
}



// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableFunction.tsx